// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2cFXi","footer":"ModalInfo_footer__R52PS"};